import { PageWrapperBase } from './PageWrapperBase';
import React from 'react';

export interface PageWrapperProps {
  children?: React.ReactNode;
}

export function PageWrapper(props: PageWrapperProps) {
  return <PageWrapperBase {...props} />;
}
